import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CibilDashboardRoutingModule } from './cibil-dashboard-routing.module';
import { CibilDashboardComponent } from './cibil-dashboard.component';
import { CommonSectionsModule } from '../../views/common/common-sections.module';
import { IndicativeLoanComponent } from './indicative-loan/indicative-loan.component';
import { QuickCashLoanComponent } from './quick-cash-loan/quick-cash-loan.component';
import { CreditBureauService } from '../../service/credit-bureau.service';
import { CibilScoresComponent } from './cibil-scores/cibil-scores.component';
import { LoansAndApplicationsSegregator } from '../borrower-dashboard/all-loans-and-applications/loans-and-applications-segregator';
import { CreditAssessmentService } from '../../service/credit-assessment.service';
import { LoanApplicationService } from '../../service/loan-application.service';
import { LoanDetailsService } from '../../service/loan-details.service';
import { StorageService } from '../../service/storage.service';
import { TooltipModule } from '../../../app/tooltip/tooltip.module';
import { MatButtonModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [CibilDashboardComponent, IndicativeLoanComponent, QuickCashLoanComponent, CibilScoresComponent],
  imports: [
    CommonModule,
    CibilDashboardRoutingModule,
    CommonSectionsModule,
    MatButtonModule,
    TooltipModule,
    MatIconModule
  ],
  providers: [
    CreditBureauService,
    LoansAndApplicationsSegregator,
    CreditAssessmentService,
    LoanApplicationService,
    LoanDetailsService,
    StorageService
  ]
})
export class CibilDashboardModule { }
